import { toast } from "react-toastify";
import { _OutputAuthorizationItem, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { useEffect, useState } from "react";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import useModal, { MODAL_md, MODAL_SM } from "../../../../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../../../theme/Component/Modal";
import { SelectProductEditor } from "../../../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { EditorFixedAssetItem } from "../../../../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/EditorFixedAssetItem";
import usePaginator from "../../../../../../theme/Component/usePaginator";

interface ComponentProps {
    _IDOutputAuthorizationRequest: number;
    _onChangeProduct?: Function;
    _onChangeFixed?: Function;
}

export const SOLAUTOutputAuthorizationItem = ({ _IDOutputAuthorizationRequest, _onChangeFixed, _onChangeProduct }: ComponentProps) => {

    const { instance } = useDataBean(_OutputAuthorizationItem);

    const pagProduct = usePaginator();
    const pagFixed = usePaginator();

    const modal = useModal("", MODAL_md);
    const modalC = useModal("", MODAL_SM);

    const [listaProduct, setListaProduct] = useState<any[]>([]);
    const [listaFixed, setListaFixed] = useState<any[]>([]);
    const [current, setCurrent] = useState<any>({});
    const [currentType, setCurrentType] = useState<number | null>(null);

    useEffect(() => {
        if (_IDOutputAuthorizationRequest) {
            getListaProduct();
        }
    }, [_IDOutputAuthorizationRequest, pagProduct.page]);

    useEffect(() => {
        if (_IDOutputAuthorizationRequest) {
            getListaFixed();
        }
    }, [_IDOutputAuthorizationRequest, pagFixed.page]);

    const getListaProduct = () => {
        const props = {
            IDOutputAuthorizationRequest: _IDOutputAuthorizationRequest,
            ItemType: 101
        };

        instance.getOutputAuthorizationItemRender(pagProduct.page, 15, props)
            .then((resp) => {
                pagProduct.setPages(resp.NumberOfPages);
                pagProduct.setRecords(resp.NumberOfPages * 15);
                pagProduct.setRegiPerPage(15)

                _onChangeProduct?.(resp.NumberOfPages);

                setListaProduct(resp.List)
            })
            .catch(() => toast.error("No se pudieron cargar los Productos"));
    };

    const getListaFixed = () => {
        const props = {
            IDOutputAuthorizationRequest: _IDOutputAuthorizationRequest,
            ItemType: 100
        };

        instance.getOutputAuthorizationItemRender(pagFixed.page, 15, props)
            .then((resp) => {
                pagFixed.setPages(resp.NumberOfPages);
                pagFixed.setRecords(resp.NumberOfPages * 15);
                pagFixed.setRegiPerPage(15)

                _onChangeFixed?.(resp.NumberOfPages);

                setListaFixed(resp.List)
            })
            .catch(() => toast.error("No se pudieron cargar los Activos"));
    };

    const createProduct = () => {
        setCurrent({
            ItemType: 101,
            IDOutputAuthorizationRequest: _IDOutputAuthorizationRequest,
            IDEmployee: _single.getAccountID(),
        });
        setCurrentType(101);
        modal.open("Agregar Prodcuto a retirar");
    };

    const createFixed = () => {
        setCurrent({
            ItemType: 100,
            IDOutputAuthorizationRequest: _IDOutputAuthorizationRequest,
            IDEmployee: _single.getAccountID(),
        });
        setCurrentType(100);
        modal.open("Agregar Acitvo Fijo a Retirar");
    };

    const setRowBean = (item: any) => {
        setCurrent(item);
        setCurrentType(item.ItemType);

    }

    const guardar = () => {
        instance.updateOutputAuthorizationItem(current)
            .then(() => {
                if (current.ItemType == 100) {
                    getListaFixed();
                } else if (current.ItemType == 101) {
                    getListaProduct();
                }
                modal.close();
            })
            .catch(err => toast.error(err));
    };

    const eliminar = () => {
        instance.deleteOutputAuthorizationItem(current.IDOutputAuthorizationItem)
            .then(() => {
                if (current.ItemType == 100) {
                    getListaFixed();
                } else if (current.ItemType == 101) {
                    getListaProduct();
                }
                modalC.close();
            });
    };


    const headFixed = [
        { title: 'ID', property: 'IDOutputAuthorizationItem', visible: true },
        { title: 'Placa', property: 'FixedAssetItemTicketCode', visible: true },
        { title: 'Activo Fijo', property: 'DescriptionFixed', visible: true },
    ];

    const headProduct = [
        { title: 'ID', property: 'IDOutputAuthorizationItem', visible: true },
        { title: 'Producto', property: 'ProductName', visible: true },
        { title: 'Cantidad', property: 'QuantityProduct', visible: true },
    ];

    const listaBotones = () => {
        return (
            <ListMenu listaBotones={[
                { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => modal.open() },
                { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: true, evento: () => { modalC.open(); } }
            ]}
            />
        );
    };

    return (
        <div className="row">

            <div className="col-md-12">
                <label>Productos a Retirar</label>
                <BasicTable
                    rowSet={setRowBean}
                    iconButtons={[
                        { nombre: 'Agregar Producto', visible: true, icono: 'ri-file-add-line', evento: createProduct }
                    ]}
                    listButtons={listaBotones()}
                    body={listaProduct}
                    head={headProduct}
                />
            </div>

            <div className="col-md-12 mt-3">
                <label>Activos Fijos a Retirar</label>
                <BasicTable
                    rowSet={setRowBean}
                    iconButtons={[
                        { nombre: 'Agregar Activo', visible: true, icono: 'ri-file-add-line', evento: createFixed }
                    ]}
                    listButtons={listaBotones()}
                    body={listaFixed}
                    head={headFixed}
                />
            </div>

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { guardar() }}>
                    <div className="row">

                        {currentType === 101 && (
                            <>
                                <div className="col-md-12">
                                    <SelectProductEditor
                                        label="Producto"
                                        onChange={(e) =>
                                            setCurrent(prev => ({ ...prev, IDProduct: e.IDProduct }))
                                        }
                                    />
                                </div>

                                <div className="col-md-12">
                                    <label>Cantidad</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={current.QuantityProduct || ''}
                                        onChange={(e) => {
                                            const valor = e.target.value ? Number(e.target.value) : null;
                                            setCurrent(prev => ({ ...prev, QuantityProduct: valor }));
                                        }}
                                    />
                                </div>
                            </>
                        )}

                        {currentType === 100 && (
                            <div className="col-md-12">
                                <EditorFixedAssetItem
                                    onChange={(e) =>
                                        setCurrent(prev => ({ ...prev, IDFixedAssetItem: e.IDItem }))
                                    }
                                />
                            </div>
                        )}

                    </div>
                </Modal>

                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={eliminar}>
                    <strong>¿Eliminar item?</strong>
                </ModalConfirm>
            </div>
        </div>
    );
};